import {generateTrackingService} from 'app/helpers/trackingTrigger';

const loadIvwLegacyScript = callback => {
  //Source: https://cleverbeagle.com/blog/articles/tutorial-how-to-load-third-party-scripts-dynamically-in-javascript
  const existingScript = document.getElementById('ioam');

  if (!existingScript) {
    const script = document.createElement('script');
    script.src = 'https://script.ioam.de/iam.js?m=1';
    script.id = 'ioam';
    document.body.appendChild(script);
    script.onload = () => {
      if (callback) {
        callback();
      }
    };
  }

  if (existingScript && callback) {
    callback();
  }
};

const pushIvwTracker = generateTrackingService();

const callIvwLegacy = ivw => {
  if (typeof window === 'undefined') {
    return;
  }

  if (!window.iom || typeof window?.iom?.c !== 'function' || !Object.keys(ivw).length) {
    return;
  }

  let st;
  let cp = ivwGetPageCategory();
  if (window.innerWidth < 768) {
    st = ivw.ivw_st_mobil;
    cp = 'mobil_' + cp;
  } else {
    st = ivw.ivw_st_desktop;
  }

  if (st === '') {
    return;
  }

  if (ivw.ivw_cp_prefix) {
    cp = ivw.ivw_cp_prefix + cp;
  }

  // From Legacy-Code: Logging for IVW without protocol + subdomain
  const co = window.location.href.replace('https://www.', '');
  const iam_data = {
    st,
    cp,
    sv: 'ke',
    co,
    sc: 'yes',
  };

  pushIvwTracker(iam_data, window.location.href, event =>
    typeof window?.iom?.c === 'function' ? window.iom.c(event, 1) : null
  );
};

const ivwGetPageCategory = () => {
  let cp = 'fp_rc_sp';

  if (window.location.pathname.startsWith('/about')) {
    cp = 'fp_rc_uk';
  }
  if (window.location.pathname.startsWith('/region')) {
    cp = 'home_fp_rc_sp';
  }

  return cp;
};

export {loadIvwLegacyScript, callIvwLegacy};
